import Locales from "./locales.vue";
import Session from "./session/session.vue";
export default {
  name: "Header",

  data() {
    return {
      envs: {
        serviceName: envs.serviceName,
        root: envs.root
      }
    };
  },

  components: {
    Locales,
    Session
  }
};